export default "__VITE_ASSET__Bw12PS0W__"